<template>
<div id="content" data-uk-height-viewport="expand: true">
<section>
	<div uk-filter="target: .js-filter">
		<div class="uk-grid-small uk-flex-middle" uk-grid style="padding-left: 100px; padding-right: 30px;">
			<div class="uk-width-expand">
				<div class="uk-grid-small uk-grid-divider uk-child-width-auto" uk-grid>
					<div>
						<ul class="uk-subnav uk-subnav-pill" uk-margin>
							<li class="uk-active" uk-filter-control><a href="#">All</a></li>
						</ul>
					</div>
					<div>
						<ul class="uk-subnav uk-subnav-pill" uk-margin>
							<li uk-filter-control="[data-size='Activa/o']"><a href="#">Activa/o</a></li>
							<li uk-filter-control="[data-size='Adherente']"><a href="#">Adherente</a></li>
							<li uk-filter-control="[data-size='Vitalicio']"><a href="#">Vitalicio</a></li>
						</ul>
					</div>
				</div>
			</div>
			<form id="search-form" action="">
				<div class="uk-inline uk-width-1-1">
					<span class="uk-form-icon uk-form-icon-flip" data-uk-icon="icon: search"></span>
					<input class="uk-input uk-width-1-1 search-fld" type="text" placeholder="Buscar" autofocus>
					<a hidden href="#" class="search-filter" data-uk-filter-control="[data-name*='']">Search</a>
					<a hidden href="#" class="search-filter-all" data-uk-filter-control>Search all</a>
					<a hidden href="#" class="search-filter-none" data-uk-filter-control="[data-empty='']">Filter none</a>
				</div>
			</form>
			<div class="uk-width-auto uk-text-nowrap">
				<span uk-filter-control="sort: data-name"><a class="uk-icon-link" href="#" uk-icon="icon: arrow-down"></a></span>
				<span uk-filter-control="sort: data-name; order: desc"><a class="uk-icon-link" href="#" uk-icon="icon: arrow-up"></a></span>
			</div>
		</div>
	</div>
</section>
</div>
</template>